export default {
    methods: {
        getLinearItems(options = this.options) {
            return options.reduce((acc, option) => {
                if (option.childNodes) {
                    acc.push(...option.childNodes.map((child) => child));
                } else {
                    acc.push(option);
                }
                return acc;
            }, []);
        },
    }
};
